import React, { useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";

import breakpoints from "_constants/breakpoints";
import { userActions } from "_store/actions";
import { credentialsActions } from "_store/actions";

import { ChangeLogin } from "components/Modals/ChangeLogin";
import { ChangePassword } from "components/Modals/ChangePassword";

import CustomerInfo from "components/PersonalInformation/CustomerInfo";
import ContactInfo from "components/PersonalInformation/ContactInfo";
import AccountInfo from "components/PersonalInformation/AccountInfo";

import Title from "containers/Title";

import { SpinnerWrapper } from "widget/Spinner";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #ffffff;
  min-height: 500px;

  animation: 0.2s linear fadeIn;
  @keyframes fadeIn {
    from {
      opacity: 0%;
    }
    to {
      opacity: 100%;
    }
  }
`;
const StyledTitle = styled(Title)`
  @media (max-width: ${breakpoints.mobileM}) {
    font-size: 18px;
  }
`;
const SubTitle = styled.div`
  height: 24px;
  margin-top: 14px;
  margin-bottom: 66px;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  color: #7b848d;

  @media (max-width: ${breakpoints.mobileM}) {
    font-size: 16px;
    margin-bottom: 48px;
    padding: 0px 16px;
  }
`;

function PersonalInformation() {
  const dispatch = useDispatch();
  const { userInfo, loading } = useSelector(({ user }) => user);
  const { credentials, credentialsLoading, credentialsUpdating } = useSelector(({ credentials }) => credentials);

  const [isOpenChangePasswordModal, setOpenChangePasswordModal] = useState(false);
  const [isOpenChangeLoginModal, setOpenChangeLoginModal] = useState(false);

  const isLoading = loading || credentialsLoading || credentialsUpdating;

  const { username } = useMemo(
    () => credentials?.find(({ brandCategory }) => brandCategory === "TRADEMARKS") || {},
    [credentials]
  );

  const handleSaveUserInfo = (user) => {
    dispatch(userActions.updateInfo(user));
  };

  const handleChangePassword = (oldPassword, newPassword) => {
    setOpenChangePasswordModal(false);
    dispatch(
      credentialsActions.setCredentials({ brandCategory: "TRADEMARKS", username, password: newPassword, oldPassword })
    );
  };

  const handleChangeLogin = (newLogin) => {
    setOpenChangeLoginModal(false);
    dispatch(credentialsActions.setCredentials({ brandCategory: "TRADEMARKS", username: newLogin }));
  };

  return (
    <Container>
      <StyledTitle>Personal Information</StyledTitle>
      <SubTitle>Update Your Personal Information</SubTitle>
      <CustomerInfo userInfo={userInfo} onSave={handleSaveUserInfo} />
      <ContactInfo userInfo={userInfo} onSave={handleSaveUserInfo} />
      <AccountInfo
        username={username}
        onLoginClick={() => setOpenChangeLoginModal(true)}
        onPasswordClick={() => setOpenChangePasswordModal(true)}
      />

      {isLoading && <SpinnerWrapper />}

      {isOpenChangeLoginModal && (
        <ChangeLogin
          username={username}
          onConfirm={handleChangeLogin}
          onCancel={() => setOpenChangeLoginModal(false)}
        />
      )}

      {isOpenChangePasswordModal && (
        <ChangePassword onConfirm={handleChangePassword} onCancel={() => setOpenChangePasswordModal(false)} />
      )}
    </Container>
  );
}

export default PersonalInformation;
